<template>
  <el-dialog
    :title="
      form.userId ? $t('text.edit_user_account') : $t('text.add_user_account')
    "
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="480px"
    @close="closeDialog()"
  >
    <div>
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        :label-width="
          store.state.locale.currentLocale === 'fr'
            ? '120px'
            : store.state.locale.currentLocale === 'de'
            ? '90px'
            : '80px'
        "
      >
        <el-form-item :label="$t('text.email')" prop="emailAddress">
          <el-input v-model="form.emailAddress"></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.username')" prop="userName">
          <el-input v-model="form.userName"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('text.password')"
          prop="password"
          v-if="!form.userId"
        >
          <el-input v-model="form.password" type="password"></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.role')" prop="roleIds">
          <el-select
            v-model="form.roleIds"
            :placeholder="$t('text.please_select')"
            multiple
            class="wp-100"
          >
            <el-option
              v-for="item in roleOptions"
              :key="item.id"
              :label="item.roleName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('text.active') | firstLetterCapitalize"
          prop="isEnabled"
        >
          <el-switch v-model="form.isEnabled"></el-switch>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="save()" :loading="loading">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import swal from 'sweetalert'
import store from '../../store/store'
import ApiService from '@/services/CommonApiService.js'
export default {
  data() {
    return {
      store: store,
      dialogVisible: false,
      loading: false,
      form: {
        userId: '',
        emailAddress: '',
        userName: '',
        password: '',
        roleIds: [],
        isEnabled: false
      },
      rules: this.initRules(),
      roleOptions: []
    }
  },
  watch: {
    'form.userId': function() {
      if (this.form.userId) {
        delete this.form.password
        delete this.rules.password
      } else {
        this.form = {
          userId: '',
          emailAddress: '',
          userName: '',
          password: '',
          roleIds: [],
          isEnabled: false
        }
        this.rules = this.initRules()
      }
    },
    '$store.state.locale.currentLocale': function() {
      this.rules = this.initRules()
    }
  },
  methods: {
    initRules() {
      return {
        emailAddress: [
          {
            required: true,
            message: this.$t('text.email_required')
          },
          {
            type: 'email',
            message: this.$t('text.enter_correct_email'),
            trigger: ['blur', 'change']
          }
        ],
        userName: [
          {
            required: true,
            message: this.$t('text.username_required')
          }
        ],
        password: [
          {
            required: true,
            message: this.$t('text.password_required'),
            trigger: 'blur'
          }
        ],
        roleIds: [
          {
            required: true,
            message: this.$t('text.role_required'),
            trigger: 'change'
          }
        ]
      }
    },
    openDialog() {
      this.dialogVisible = true
      this.getRoles()
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    getRoles() {
      ApiService.GetRoles()
        .then(response => {
          if (response.data.success) {
            this.roleOptions = response.data.data
          } else {
            // swal({
            //   icon: 'error',
            //   timer: 2000,
            //   title: 'Failed',
            //   text: response.data.msg
            // })
          }
        })
        .catch(() => {
          // swal({
          //   icon: 'error',
          //   timer: 2000,
          //   title: 'Failed'
          // })
        })
    },
    save() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (!this.form.userId) {
            this.add()
          } else {
            this.edit()
          }
        }
      })
    },
    resetForm() {
      this.form = {
        userId: '',
        emailAddress: '',
        userName: '',
        password: '',
        roleIds: [],
        isEnabled: false
      }
      this.$refs['form'].resetFields()
    },
    add() {
      this.loading = true
      let params = JSON.parse(JSON.stringify(this.form))
      delete params.userId
      ApiService.CreateUser(params)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              title: this.$t('text.saved_successfully'),
              timer: 2000
            })
            this.$parent.getUserList()
            this.closeDialog()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Failed'
          })
        })
    },
    edit() {
      this.loading = true
      let params = JSON.parse(JSON.stringify(this.form))
      delete params.userId
      delete params.password
      ApiService.UpdateUser(this.form.userId, params)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              title: this.$t('text.saved_successfully'),
              timer: 2000
            })
            this.$parent.getUserList()
            this.closeDialog()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: 'Failed',
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: 'Failed'
          })
        })
    }
  }
}
</script>
